import { createFileRoute } from '@tanstack/react-router'
import {UserProfile} from "@descope/react-sdk";
import { SettingsIcon } from 'lucide-react'
import { PageWrapper } from '@nxt-shared/ui/components/PageWrapper'
import { PageHeader } from '@nxt-shared/ui/components/PageHeader'
import { PageContent } from '@nxt-shared/ui/components/PageContent'
import { usePageTitle } from '../../../features/page-title/pageTitle'

export const Route = createFileRoute('/me/_settings/account')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTitle('Account')
  return (
    <PageWrapper>
      <PageHeader
        title="Account"
        icon={SettingsIcon}
        description="The email you sign in with and the ways you sign in to Tickaroo."
        transparent
      />
      <PageContent className="pt-0 xl:pt-0 pb-8 xl:pb-12" stableScrollbarGutter>
        <UserProfile widgetId="user-authentication-widget" />
      </PageContent>
    </PageWrapper>
  )
}
